import { Component, Input } from '@angular/core';
import { Exercise } from '../../../models/types';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-exercise-modal-page',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './exercise-modal-page.component.html',
  styleUrl: './exercise-modal-page.component.scss'
})
export class ExerciseModalPageComponent {
  @Input() exercise: Exercise | null = null;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
    console.log(this.exercise);
  }
  
  closeModal() {
    this.activeModal.close(); // Use NgbActiveModal to close
  }

}
